import { usePermissions, useTranslate } from "react-admin";

import { Button } from "@material-ui/core";
import ContentAdd from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import React from "react";
import { get } from "lodash";
import { stringify } from "query-string";
import { useLocation } from "react-router-dom";

const AddDocButton = ({ resource, source, record }) => {
  const translate = useTranslate();
  const location = useLocation();
  const { loaded, permissions } = usePermissions();
  const canAddDoc = loaded && permissions(["admin", "admissibility_evaluator"]);
  if (!canAddDoc) {
    return null;
  }
  return (
    <Button
      startIcon={<ContentAdd />}
      component={Link}
      disableElevation
      variant="outlined"
      color="primary"
      to={{
        pathname: `/research-project-docs/create`,
        search: stringify({
          source: JSON.stringify({
            research_project_id: get(record, "id"),
            view: 1,
          }),
        }),
        state: {
          from: location,
        },
      }}
    >
      {translate(`resources.${resource}.buttons.add_${source}`)}
    </Button>
  );
};

export default AddDocButton;
